// extracted by mini-css-extract-plugin
module.exports = {"calculator__title":"Calculator_calculator__title__dj10x","calculator__form":"Calculator_calculator__form__ef9jJ"};